
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/opendock",
      function () {
        return require("private-next-pages/opendock.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/opendock"])
      });
    }
  